var _path, _circle, _g, _use, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 600,
    viewBox: "-225 -114 450 300",
    width: 900,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-225-114h450v300h-450z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#ce1126",
    r: 64.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0c-2.167 0-3 3.25-3 6.5 0 7.833.96 11.929 3 23.5C2.04 18.429 3 14.333 3 6.5 3 3.25 2.167 0 0 0z",
    fill: "#ce1126",
    transform: "translate(0 -102)"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(5)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(10)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(20)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(40)",
    xlinkHref: "#d"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-80)",
    xlinkHref: "#e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-225-21.5h450V186h-450z",
    strokeWidth: 5.26
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-225-14h450v200h-450z",
    fill: "#ce1126",
    strokeWidth: 1.414
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-225 86h450v100h-450z",
    fill: "#339e35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/mw.1307c519cba4e1a4a2ec4dfaf2dc6dd1.svg";
export { ForwardRef as ReactComponent };